// extracted by mini-css-extract-plugin
var _1 = "FileAttachedItemsModal-moduletable__lxSEU TableComponent-moduleTable__mhqNq";
export { _1 as "table" }
